<template>
  <div class="advantage">
    <h1>{{$t('home.advantageTitlt')}}</h1>
    <div class="advantage_list">
      <div>
        <div class="advantage_items">
          <img src="@/assets/images/hx_js.png" alt />
          <div>
            <h2>{{$t('home.advantageTitlt1')}}</h2>
            <p>{{$t('home.advantageContent1')}}</p>
          </div>
        </div>
        <div class="advantage_items">
          <img src="@/assets/images/hx_nncy.png" alt />
          <div>
            <h2>{{$t('home.advantageTitlt2')}}</h2>
            <p>{{$t('home.advantageContent2')}}</p>
          </div>
        </div>
        <div class="advantage_items">
          <img src="@/assets/images/hx_meiti.png" alt />
          <div>
            <h2>{{$t('home.advantageTitlt3')}}</h2>
            <p>{{$t('home.advantageContent3')}}</p>
          </div>
        </div>
      </div>
      <div>
        <div class="advantage_items">
          <img src="@/assets/images/hx_td.png" alt />
          <div>
            <h2>{{$t('home.advantageTitlt4')}}</h2>
            <p>{{$t('home.advantageContent4')}}</p>
          </div>
        </div>
        <div class="advantage_items">
          <img src="@/assets/images/hx_ggkh.png" alt />
          <div>
            <h2>{{$t('home.advantageTitlt5')}}</h2>
            <p>{{$t('home.advantageContent5')}}</p>
          </div>
        </div>
        <div class="advantage_items">
          <img src="@/assets/images/hx_cpcx.png" alt />
          <div>
            <h2>{{$t('home.advantageTitlt6')}}</h2>
            <p>{{$t('home.advantageContent6')}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.advantage {
  width: 1200px;
  margin: auto;
  padding: 64px 0 80px;
  & h1 {
    margin-bottom: 10px;
  }
  & p {
    font-size: 20px;
    color: #666666;
    letter-spacing: 0;
    line-height: 28px;
  }
  & .advantage_list {
    padding-top: 64px;
    display: flex;
    & > div {
      width: 600px;
      display: flex;
      flex-direction: column;
      & .advantage_items {
        height: 91px;
        display: flex;
        & img {
          width: 88px;
          height: 88px;
          margin-right: 32px;
        }
        & > div {
          flex: 1;
          & h2 {
            margin-bottom: 10px;
            color: #000;
          }
          & p {
            width: 307px;
            font-size: 16px;
            color: #666666;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
      }
      & .advantage_items:nth-child(1),
      & .advantage_items:nth-child(2) {
        margin-bottom: 64px;
      }
    }
  }
}
</style>